// Generated by tools/lucide-icons.mjs. Do not edit.
import {
  Activity,
  Anchor,
  Apple,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  BadgeCheck,
  BadgePercent,
  Ban,
  Banknote,
  BanknoteX,
  BatteryFull,
  Beaker,
  Bell,
  BellRing,
  Binary,
  Bird,
  Bold,
  Bone,
  BookOpen,
  Boxes,
  Braces,
  BriefcaseBusiness,
  Bug,
  Building,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarHeart,
  CalendarOff,
  CalendarPlus,
  CalendarRange,
  CalendarSync,
  CalendarX,
  Camera,
  CaseSensitive,
  Cat,
  ChartBar,
  ChartColumn,
  ChartLine,
  ChartNoAxesColumnIncreasing,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsLeft,
  ChevronsRight,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleCheckBig,
  CircleDashed,
  CircleDot,
  CirclePlus,
  CircleQuestionMark,
  CircleSlash,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  ClipboardPlus,
  Clock,
  Clock3,
  Cloud,
  CloudOff,
  CloudUpload,
  Code,
  Coins,
  Contact,
  Container,
  Contrast,
  Cookie,
  Copy,
  CornerDownRight,
  Cpu,
  CreditCard,
  Crop,
  Currency,
  Database,
  DatabaseZap,
  Delete,
  Dog,
  Download,
  Droplet,
  Ellipsis,
  EllipsisVertical,
  Eraser,
  Euro,
  ExternalLink,
  Eye,
  EyeOff,
  Facebook,
  File,
  FileCheck,
  FileClock,
  FileDown,
  FileMinus,
  FilePen,
  FilePenLine,
  FilePlus,
  FileSearch,
  FileText,
  FileType,
  FileUp,
  FileX,
  Files,
  FingerprintPattern,
  Fish,
  Flag,
  FlaskConical,
  Flower2,
  Form,
  Funnel,
  FunnelX,
  Gauge,
  Ghost,
  Gift,
  GitBranch,
  GitCompareArrows,
  Globe,
  GripVertical,
  Group,
  HandCoins,
  Hash,
  Heading,
  Headset,
  HeartCrack,
  HeartOff,
  HeartPulse,
  History,
  Hourglass,
  IdCard,
  Image,
  ImageOff,
  Inbox,
  Info,
  Instagram,
  Italic,
  Key,
  KeyRound,
  Landmark,
  Languages,
  Laptop,
  Layers,
  LayoutDashboard,
  LayoutGrid,
  LifeBuoy,
  Link,
  List,
  ListChecks,
  ListFilter,
  LoaderCircle,
  Lock,
  LockKeyhole,
  LogIn,
  LogOut,
  Mail,
  MailCheck,
  MailOpen,
  MailPlus,
  MailWarning,
  MailX,
  MapPin,
  Maximize2,
  Megaphone,
  MegaphoneOff,
  Menu,
  Merge,
  MessageCircle,
  MessageSquare,
  MessageSquarePlus,
  MessageSquareWarning,
  Mic,
  MicOff,
  Minus,
  Monitor,
  MoonStar,
  Mouse,
  MousePointerClick,
  MoveHorizontal,
  Navigation,
  Network,
  Nfc,
  OctagonAlert,
  Option,
  Package,
  PackageCheck,
  Palette,
  PanelLeftClose,
  PanelLeftOpen,
  Paperclip,
  Pause,
  PawPrint,
  Pencil,
  Percent,
  Phone,
  Pill,
  Pin,
  Play,
  Plug,
  PlugZap,
  Plus,
  PowerOff,
  Presentation,
  Rabbit,
  Radio,
  Rat,
  Receipt,
  RefreshCw,
  Repeat,
  Replace,
  Rocket,
  Rose,
  RotateCcw,
  RotateCw,
  Route,
  Ruler,
  Save,
  Scale,
  ScanFace,
  ScanSearch,
  Search,
  SearchX,
  Section,
  Send,
  ServerCrash,
  Settings,
  Share2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldHalf,
  ShieldOff,
  ShieldX,
  SignalHigh,
  Signature,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Split,
  SquareCheck,
  SquarePen,
  Squirrel,
  Star,
  Stethoscope,
  StickyNote,
  Sun,
  Syringe,
  Tablet,
  Tag,
  Tags,
  Target,
  Terminal,
  TextAlignStart,
  Thermometer,
  Ticket,
  TicketCheck,
  TicketX,
  TimerOff,
  ToggleRight,
  Trash2,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Turtle,
  Type,
  Underline,
  Undo2,
  Unlink,
  Unplug,
  Upload,
  Usb,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserRound,
  UserRoundCheck,
  UserRoundPlus,
  UserSearch,
  UserX,
  Users,
  UsersRound,
  Utensils,
  View,
  Wallet,
  WalletCards,
  Webhook,
  Weight,
  Wifi,
  Wind,
  X,
  ZoomIn,
  ZoomOut,
} from 'lucide-angular';

/** The 302 lucide icons this app can reach. */
export const WEB_LUCIDE_ICONS = {
  Activity,
  Anchor,
  Apple,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowRightLeft,
  ArrowUp,
  BadgeCheck,
  BadgePercent,
  Ban,
  Banknote,
  BanknoteX,
  BatteryFull,
  Beaker,
  Bell,
  BellRing,
  Binary,
  Bird,
  Bold,
  Bone,
  BookOpen,
  Boxes,
  Braces,
  BriefcaseBusiness,
  Bug,
  Building,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarHeart,
  CalendarOff,
  CalendarPlus,
  CalendarRange,
  CalendarSync,
  CalendarX,
  Camera,
  CaseSensitive,
  Cat,
  ChartBar,
  ChartColumn,
  ChartLine,
  ChartNoAxesColumnIncreasing,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsLeft,
  ChevronsRight,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleCheckBig,
  CircleDashed,
  CircleDot,
  CirclePlus,
  CircleQuestionMark,
  CircleSlash,
  CircleX,
  ClipboardCheck,
  ClipboardList,
  ClipboardPlus,
  Clock,
  Clock3,
  Cloud,
  CloudOff,
  CloudUpload,
  Code,
  Coins,
  Contact,
  Container,
  Contrast,
  Cookie,
  Copy,
  CornerDownRight,
  Cpu,
  CreditCard,
  Crop,
  Currency,
  Database,
  DatabaseZap,
  Delete,
  Dog,
  Download,
  Droplet,
  Ellipsis,
  EllipsisVertical,
  Eraser,
  Euro,
  ExternalLink,
  Eye,
  EyeOff,
  Facebook,
  File,
  FileCheck,
  FileClock,
  FileDown,
  FileMinus,
  FilePen,
  FilePenLine,
  FilePlus,
  FileSearch,
  FileText,
  FileType,
  FileUp,
  FileX,
  Files,
  FingerprintPattern,
  Fish,
  Flag,
  FlaskConical,
  Flower2,
  Form,
  Funnel,
  FunnelX,
  Gauge,
  Ghost,
  Gift,
  GitBranch,
  GitCompareArrows,
  Globe,
  GripVertical,
  Group,
  HandCoins,
  Hash,
  Heading,
  Headset,
  HeartCrack,
  HeartOff,
  HeartPulse,
  History,
  Hourglass,
  IdCard,
  Image,
  ImageOff,
  Inbox,
  Info,
  Instagram,
  Italic,
  Key,
  KeyRound,
  Landmark,
  Languages,
  Laptop,
  Layers,
  LayoutDashboard,
  LayoutGrid,
  LifeBuoy,
  Link,
  List,
  ListChecks,
  ListFilter,
  LoaderCircle,
  Lock,
  LockKeyhole,
  LogIn,
  LogOut,
  Mail,
  MailCheck,
  MailOpen,
  MailPlus,
  MailWarning,
  MailX,
  MapPin,
  Maximize2,
  Megaphone,
  MegaphoneOff,
  Menu,
  Merge,
  MessageCircle,
  MessageSquare,
  MessageSquarePlus,
  MessageSquareWarning,
  Mic,
  MicOff,
  Minus,
  Monitor,
  MoonStar,
  Mouse,
  MousePointerClick,
  MoveHorizontal,
  Navigation,
  Network,
  Nfc,
  OctagonAlert,
  Option,
  Package,
  PackageCheck,
  Palette,
  PanelLeftClose,
  PanelLeftOpen,
  Paperclip,
  Pause,
  PawPrint,
  Pencil,
  Percent,
  Phone,
  Pill,
  Pin,
  Play,
  Plug,
  PlugZap,
  Plus,
  PowerOff,
  Presentation,
  Rabbit,
  Radio,
  Rat,
  Receipt,
  RefreshCw,
  Repeat,
  Replace,
  Rocket,
  Rose,
  RotateCcw,
  RotateCw,
  Route,
  Ruler,
  Save,
  Scale,
  ScanFace,
  ScanSearch,
  Search,
  SearchX,
  Section,
  Send,
  ServerCrash,
  Settings,
  Share2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldHalf,
  ShieldOff,
  ShieldX,
  SignalHigh,
  Signature,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Split,
  SquareCheck,
  SquarePen,
  Squirrel,
  Star,
  Stethoscope,
  StickyNote,
  Sun,
  Syringe,
  Tablet,
  Tag,
  Tags,
  Target,
  Terminal,
  TextAlignStart,
  Thermometer,
  Ticket,
  TicketCheck,
  TicketX,
  TimerOff,
  ToggleRight,
  Trash2,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Turtle,
  Type,
  Underline,
  Undo2,
  Unlink,
  Unplug,
  Upload,
  Usb,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserRound,
  UserRoundCheck,
  UserRoundPlus,
  UserSearch,
  UserX,
  Users,
  UsersRound,
  Utensils,
  View,
  Wallet,
  WalletCards,
  Webhook,
  Weight,
  Wifi,
  Wind,
  X,
  ZoomIn,
  ZoomOut,
};
